<template lang="html">
  <div class="promo-price flex flex-wrap items-baseline gap-2" :class="props.class">
    <span
      v-if="showDiscount"
      class="text-sm text-muted line-through"
    >
      {{ $f.currency(basePrice) }}
    </span>
    <span
      class="font-bold"
      :class="showDiscount ? 'text-success' : ''"
    >
      {{ $f.currency(displayPrice) }}
    </span>
    <UBadge
      v-if="!props.hideDetails && discountPercent != null"
      size="xs"
      color="error"
      variant="subtle"
      class="promo-price__percent"
    >
      {{ formatDiscountPercent(discountPercent) }}
    </UBadge>
    <span
      v-if="!props.hideDetails && cashback"
      class="promo-price__cashback basis-full text-xs text-info"
    >
      +{{ $f.currency(cashback.amount) }} бонусами
    </span>
  </div>
</template>

<script setup lang="ts">
import {
  computeDiscountPercent,
  formatDiscountPercent,
  getBasePrice,
  getCashback,
  getCatalogPromoPrice,
  getDiscountPercent,
  getEffectiveCatalogPrice,
  hasVisualDiscount,
  type PromoPriceSource,
} from '#Promotion/utils/promoPrice'

const props = defineProps<{
  value: PromoPriceSource
  unitPrice?: number | null
  /** Только цены, без «−N%» и кэшбэка (карточка заказа: итог уже зафиксирован снимком). */
  hideDetails?: boolean
  class?: string
}>()

const { $f } = useFormatter()

const basePrice = computed(() => getBasePrice(props.value))
const catalogPromoPrice = computed(() => getCatalogPromoPrice(props.value))

const showDiscount = computed(() => {
  if (props.unitPrice != null) {
    return props.unitPrice < basePrice.value
  }

  return hasVisualDiscount(basePrice.value, catalogPromoPrice.value)
})

const displayPrice = computed(() => {
  if (props.unitPrice != null) {
    return props.unitPrice
  }

  return getEffectiveCatalogPrice(props.value)
})

// В корзине процент считается от фактической цены за единицу (после стекинга, потолка,
// количества) — иначе число разойдётся с суммой строки.
const discountPercent = computed(() => {
  if (props.unitPrice != null) {
    return computeDiscountPercent(basePrice.value, props.unitPrice)
  }

  return getDiscountPercent(props.value)
})

const cashback = computed(() => getCashback(props.value))
</script>
